{
  "classes": [
    "Archer",
    "Bard",
    "Calculator",
    "Chemist",
    "Dancer",
    "Geomancer",
    "Knight",
    "Lancer",
    "Mediator",
    "Mime",
    "Monk",
    "Ninja",
    "Oracle",
    "Priest",
    "Samurai",
    "Squire",
    "Summoner",
    "Thief",
    "Time Mage",
    "Wizard"
  ],
  "classIndex": {
    "Archer": 3,
    "Bard": 17,
    "Calculator": 16,
    "Chemist": 1,
    "Dancer": 17,
    "Geomancer": 12,
    "Knight": 2,
    "Lancer": 13,
    "Mediator": 10,
    "Mime": 18,
    "Monk": 4,
    "Ninja": 15,
    "Oracle": 11,
    "Priest": 5,
    "Samurai": 14,
    "Squire": 0,
    "Summoner": 8,
    "Thief": 9,
    "Time Mage": 7,
    "Wizard": 6
  },
  "monsters": [
    "Ahriman",
    "Apanda",
    "Archaic Demon",
    "Behemoth",
    "Black Chocobo",
    "Black Goblin",
    "Blue Dragon",
    "Bomb",
    "Bull Demon",
    "Byblos",
    "Chocobo",
    "Cockatrice",
    "Coeurl",
    "Dark Behemoth",
    "Dragon",
    "Draugr",
    "Dryad",
    "Explosive",
    "Floating Eye",
    "Ghost",
    "Ghoul",
    "Gobbledeguck",
    "Goblin",
    "Great Malboro",
    "Grenade",
    "Holy Dragon",
    "Hydra",
    "Iron Hawk",
    "Juravis",
    "King Behemoth",
    "Malboro",
    "Mindflayer",
    "Minotaur",
    "Ochu",
    "Pisco Demon",
    "Plague",
    "Porky",
    "Reaper",
    "Red Chocobo",
    "Red Dragon",
    "Red Panther",
    "Revenant",
    "Sekhret",
    "Serpentarius",
    "Skeleton",
    "Squidraken",
    "Steel Giant",
    "Swine",
    "Taiju",
    "Tiamat",
    "Treant",
    "Ultima Demon",
    "Vampire",
    "Wild Boar",
    "Wyvern"
  ],
  "monsterSkills": {
    "Ahriman": [
      "Wing Attack",
      "Look of Devil",
      "Look of Fright",
      "Doom*"
    ],
    "Apanda": [
      "Bio Tenebris",
      "Bio Venenum",
      "Bio Oleum",
      "Bio Ranae",
      "Bio Tardus",
      "Bio Silentium",
      "Bio Lapis",
      "Bio Immortuos",
      "Bio Mortem",
      "Bio Insanis"
    ],
    "Archaic Demon": [
      "Lifebreak",
      "Dark Holy",
      "Giga Flare",
      "Empower",
      "Despair",
      "Despair 2"
    ],
    "Behemoth": [
      "Stab Up",
      "Frozen Cry",
      "Giga Flare*"
    ],
    "Black Chocobo": [
      "Choco Attack",
      "Choco Ball",
      "Choco Esuna",
      "Choco Meteor*"
    ],
    "Black Goblin": [
      "Tackle",
      "Turn Punch",
      "Goblin Punch",
      "Mutilate*"
    ],
    "Blue Dragon": [
      "Slam",
      "Ice Breath",
      "Tail Swing",
      "Fire Breath*"
    ],
    "Bomb": [
      "Bite",
      "Self Destruct",
      "Flame Attack",
      "Spark*"
    ],
    "Bull Demon": [
      "Shake Off",
      "Storm Around",
      "Blow Fire*"
    ],
    "Byblos": [
      "Energize",
      "Parasite",
      "Vengeance",
      "Manaburn",
      "Chicken"
    ],
    "Chocobo": [
      "Choco Attack",
      "Choco Cure",
      "Choco Esuna",
      "Choco Ball*"
    ],
    "Cockatrice": [
      "Scratch Up",
      "Beak",
      "Feather Bomb",
      "Peck*"
    ],
    "Coeurl": [
      "Scratch",
      "Cat Kick",
      "Blaster",
      "Poison Nail*"
    ],
    "Dark Behemoth": [
      "Stab Up",
      "Frozen Cry",
      "Ulmaguest*"
    ],
    "Dragon": [
      "Slam",
      "Thunder Breath",
      "Tail Swing",
      "Ice Breath*"
    ],
    "Draugr": [
      "Knife Hand",
      "Aqua Soul",
      "Frost Soul",
      "Wind Soul*"
    ],
    "Dryad": [
      "Leaf Dance",
      "Calm Spirit",
      "Protect Spirit",
      "Spirit of Life*"
    ],
    "Explosive": [
      "Bite",
      "Self Destruct",
      "Spark",
      "Small Bomb*"
    ],
    "Floating Eye": [
      "Wing Attack",
      "Look of Fright",
      "Beam",
      "Look of Devil*"
    ],
    "Ghost": [
      "Throw Spirit",
      "Grease Touch",
      "Drain Touch",
      "Zombie Touch*"
    ],
    "Ghoul": [
      "Throw Spirit",
      "Sleep Touch",
      "Knife Hand",
      "Grease Touch*"
    ],
    "Gobbledeguck": [
      "Tackle",
      "Eye Gouge",
      "Mutilate",
      "Goblin Punch*"
    ],
    "Goblin": [
      "Tackle",
      "Eye Gouge",
      "Goblin Punch",
      "Turn Punch*"
    ],
    "Great Malboro": [
      "Tendrils",
      "Bad Breath",
      "Moldball Virus",
      "Goo*"
    ],
    "Grenade": [
      "Bite",
      "Small Bomb",
      "Self Destruct",
      "Flame Attack*"
    ],
    "Holy Dragon": [
      "Holy Breath",
      "Fire Breath",
      "Ice Breath",
      "Thunder Breath"
    ],
    "Hydra": [
      "Triple Attack",
      "Triple Flame",
      "Triple Thunder*"
    ],
    "Iron Hawk": [
      "Scratch Up",
      "Peck",
      "Shine Lover",
      "Feather Bomb*"
    ],
    "Juravis": [
      "Scratch Up",
      "Feather Bomb",
      "Shine Lover",
      "Fury*"
    ],
    "King Behemoth": [
      "Stab Up",
      "Frozen Cry",
      "Hurricane*"
    ],
    "Malboro": [
      "Tendrils",
      "Lick",
      "Noxious Gas",
      "Bad Breath*"
    ],
    "Mindflayer": [
      "Tentacle",
      "Mind Blast",
      "Odd Soundwave",
      "Level Blast*"
    ],
    "Minotaur": [
      "Shake Off",
      "Blow Fire",
      "Gather Power*"
    ],
    "Ochu": [
      "Tendrils",
      "Goo",
      "Lick",
      "Noxious Gas*"
    ],
    "Pisco Demon": [
      "Tentacle",
      "Black Ink",
      "Level Blast",
      "Odd Soundwave*"
    ],
    "Plague": [
      "Wing Attack",
      "Doom",
      "Look of Devil",
      "Beam*"
    ],
    "Porky": [
      "Straight Dash",
      "Toot",
      "Bequeath Bacon",
      "Snort*"
    ],
    "Reaper": [
      "Knife Hand",
      "Wind Soul",
      "Thunder Soul",
      "Frost Soul*"
    ],
    "Red Chocobo": [
      "Choco Attack",
      "Choco Meteor",
      "Choco Ball",
      "Choco Cure*"
    ],
    "Red Dragon": [
      "Slam",
      "Fire Breath",
      "Tail Swing",
      "Thunder Breath*"
    ],
    "Red Panther": [
      "Scratch",
      "Poison Nail",
      "Cat Kick",
      "Accumulate*"
    ],
    "Revenant": [
      "Throw Spirit",
      "Drain Touch",
      "Zombie Touch",
      "Sleep Touch*"
    ],
    "Sekhret": [
      "Shake Off",
      "Mimic Titan",
      "Gather Power",
      "Storm Around*"
    ],
    "Serpentarius": [
      "Snake Carrier",
      "Toxic Toad",
      "Midgar Swarm",
      "Scream"
    ],
    "Skeleton": [
      "Knife Hand",
      "Thunder Soul",
      "Frost Soul",
      "Aqua Soul*"
    ],
    "Squidraken": [
      "Tentacle",
      "Black Ink",
      "Odd Soundwave",
      "Mind Blast*"
    ],
    "Steel Giant": [
      "Destroy",
      "Compress",
      "Dispose",
      "Repair"
    ],
    "Swine": [
      "Straight Dash",
      "Oink",
      "Bequeath Bacon",
      "Toot*"
    ],
    "Taiju": [
      "Leaf Dance",
      "Magic Spirit",
      "Spirit of Life",
      "Magic Barrier*"
    ],
    "Tiamat": [
      "Triple Attack",
      "Triple Thunder",
      "Triple Breath",
      "Dark Whisper*"
    ],
    "Treant": [
      "Leaf Dance",
      "Spirit of Life",
      "Protect Spirit",
      "Calm Spirit*"
    ],
    "Ultima Demon": [
      "Nanoflare",
      "Dark Holy",
      "Ultima",
      "Hurricane",
      "Ulmaguest",
      "Empower"
    ],
    "Vampire": [
      "Scratch",
      "Blaster",
      "Blood Suck",
      "Cat Kick*"
    ],
    "Wild Boar": [
      "Straight Dash",
      "Snort",
      "Bequeath Bacon",
      "Oink*"
    ],
    "Wyvern": [
      "Triple Attack",
      "Noxious Gas",
      "Triple Breath*"
    ]
  },
  "reactions": [
    "Abandon",
    "Absorb Used MP",
    "Arrow Guard",
    "Auto Potion",
    "Blade Grasp",
    "Brave Save",
    "Catch",
    "Caution",
    "Counter",
    "Counter Flood",
    "Counter Magic",
    "Counter Tackle",
    "Critical Quick",
    "Damage Split",
    "Distribute",
    "Dragon Spirit",
    "Earplug",
    "Faith Save",
    "HP Restore",
    "Hamedo",
    "MA Save",
    "MP Restore",
    "Mana Shield",
    "Meatbone Slash",
    "PA Save",
    "Parry",
    "Regenerator",
    "Speed Save",
    "Sunken State"
  ],
  "supports": [
    "Attack Up",
    "Beastmaster",
    "Concentrate",
    "Defend",
    "Defense Up",
    "Doublehand",
    "Dual Wield",
    "Equip Armor",
    "Equip Axe",
    "Equip Bow",
    "Equip Gun",
    "Equip Knife",
    "Equip Polearm",
    "Equip Shield",
    "Equip Sword",
    "Halve MP",
    "Long Status",
    "Magic Attack Up",
    "Magic Defense Up",
    "Maintenance",
    "Martial Arts",
    "Monster Talk",
    "Secret Hunt",
    "Short Charge",
    "Short Status",
    "Sicken",
    "Throw Item"
  ],
  "movements": [
    "Fly",
    "Ignore Height",
    "Ignore Terrain",
    "Jump+1",
    "Jump+2",
    "Jump+3",
    "Lava Walking",
    "Levitate",
    "Lifefont",
    "Manafont",
    "Move+1",
    "Move+2",
    "Move+3",
    "Pilgrimage",
    "Retreat",
    "Sonic Step",
    "Swim",
    "Teleport",
    "Teleport 2",
    "Waterwalking"
  ],
  "zodiacs": [
    "Aquarius",
    "Aries",
    "Cancer",
    "Capricorn",
    "Gemini",
    "Leo",
    "Libra",
    "Pisces",
    "Sagittarius",
    "Scorpio",
    "Serpentarius",
    "Taurus",
    "Virgo"
  ],
  "skillsets": {
    "Archer": {
      "skillset": "Charge",
      "primaryBaseChance": 40,
      "abilities": [
        "Charge+1",
        "Charge+10",
        "Charge+2",
        "Charge+20",
        "Charge+3",
        "Charge+4",
        "Charge+5",
        "Charge+7"
      ]
    },
    "Bard": {
      "skillset": "Sing",
      "primaryBaseChance": 40,
      "abilities": [
        "Angel Song",
        "Battle Song",
        "Cheer Song",
        "Diamond Blade",
        "Hydra Pit",
        "Last Song",
        "Life Song",
        "Magic Song",
        "Nameless Song",
        "Sky Demon",
        "Space Storage"
      ]
    },
    "Calculator": {
      "skillset": "Math Skill",
      "primaryBaseChance": 48,
      "abilities": [
        "3",
        "4",
        "5",
        "CT",
        "Height",
        "Prime Number"
      ]
    },
    "Chemist": {
      "skillset": "Item",
      "primaryBaseChance": 40,
      "abilities": [
        "Antidote",
        "Echo Grass",
        "Elixir",
        "Ether",
        "Eye Drop",
        "Hi-Ether",
        "Hi-Potion",
        "Holy Water",
        "Maiden's Kiss",
        "Phoenix Down",
        "Potion",
        "Remedy",
        "Soft",
        "X-Potion"
      ]
    },
    "Dancer": {
      "skillset": "Dance",
      "primaryBaseChance": 40,
      "abilities": [
        "Disillusion",
        "Dragon Pit",
        "Last Dance",
        "Nameless Dance",
        "Nether Demon",
        "Obsidian Blade",
        "Polka Polka",
        "Slow Dance",
        "Void Storage",
        "Witch Hunt",
        "Wiznaibus"
      ]
    },
    "Geomancer": {
      "skillset": "Elemental",
      "primaryBaseChance": 62,
      "abilities": [
        "Blizzard",
        "Gusty Wind",
        "Hallowed Ground",
        "Hell Ivy",
        "Lava Ball",
        "Local Quake",
        "Pitfall",
        "Quicksand",
        "Sand Storm",
        "Static Shock",
        "Water Ball",
        "Will-O-Wisp"
      ]
    },
    "Knight": {
      "skillset": "Battle Skill",
      "primaryBaseChance": 40,
      "abilities": [
        "Armor Rend",
        "Dark Sword",
        "Explosion Sword",
        "Head Rend",
        "Justice Sword",
        "Magic Ruin",
        "Mind Break",
        "Night Sword",
        "Power Break",
        "Shield Rend",
        "Speed Break",
        "Stasis Sword",
        "Surging Sword",
        "Weapon Rend"
      ]
    },
    "Lancer": {
      "skillset": "Jump",
      "primaryBaseChance": 40,
      "abilities": [
        "Level Jump2",
        "Level Jump3",
        "Level Jump4",
        "Level Jump5",
        "Level Jump6",
        "Level Jump7",
        "Vertical Jump2",
        "Vertical Jump3",
        "Vertical Jump4",
        "Vertical Jump5",
        "Vertical Jump6",
        "Vertical Jump7"
      ]
    },
    "Mediator": {
      "skillset": "Talk Skill",
      "primaryBaseChance": 40,
      "abilities": [
        "Death Sentence",
        "Insult",
        "Invitation",
        "Mimic Daravon",
        "Negotiate",
        "Persuade",
        "Praise",
        "Preach",
        "Refute",
        "Rehabilitate",
        "Solution",
        "Threaten"
      ]
    },
    "Mime": {
      "skillset": null,
      "primaryBaseChance": 40,
      "abilities": [
        "Mimic"
      ]
    },
    "Monk": {
      "skillset": "Punch Art",
      "primaryBaseChance": 40,
      "abilities": [
        "Chakra",
        "Earth Slash",
        "Pummel",
        "Purification",
        "Revive",
        "Seal Evil",
        "Secret Fist",
        "Spin Fist",
        "Wave Fist"
      ]
    },
    "Ninja": {
      "skillset": "Throw",
      "primaryBaseChance": 40,
      "abilities": [
        "Axe",
        "Bomb",
        "Dictionary",
        "Hammer",
        "Knife",
        "Ninja Sword",
        "Shuriken",
        "Spear",
        "Staff",
        "Stick",
        "Sword",
        "Wand"
      ]
    },
    "Oracle": {
      "skillset": "Yin Yang Magic",
      "primaryBaseChance": 40,
      "abilities": [
        "Blind",
        "Confuse",
        "Dark Holy",
        "Dispel Magic",
        "Doubt Faith",
        "Enrage",
        "Foxbird",
        "Life Drain",
        "Paralyze",
        "Petrify",
        "Poison",
        "Pray Faith",
        "Silence",
        "Sleep",
        "Spell Absorb",
        "Zombie"
      ]
    },
    "Priest": {
      "skillset": "White Magic",
      "primaryBaseChance": 40,
      "abilities": [
        "Cure",
        "Cure 2",
        "Cure 3",
        "Cure 4",
        "Esuna",
        "Holy",
        "Magic Barrier",
        "Protect",
        "Protect 2",
        "Raise",
        "Raise 2",
        "Regen",
        "Reraise",
        "Shell",
        "Shell 2",
        "Wall"
      ]
    },
    "Samurai": {
      "skillset": "Draw Out",
      "primaryBaseChance": 40,
      "abilities": [
        "Asura",
        "Bizen Boat",
        "Chirijiraden",
        "Heaven's Cloud",
        "Kikuichimonji",
        "Kiyomori",
        "Koutetsu",
        "Masamune",
        "Muramasa",
        "Murasame"
      ]
    },
    "Squire": {
      "skillset": "Basic Skill",
      "primaryBaseChance": 40,
      "abilities": [
        "Accumulate",
        "Cheer Up",
        "Dash",
        "Fury",
        "Heal",
        "Scream",
        "Throw Stone",
        "Tickle",
        "Ultima",
        "Wish",
        "Yell"
      ]
    },
    "Summoner": {
      "skillset": "Summon Magic",
      "primaryBaseChance": 40,
      "abilities": [
        "Bahamut",
        "Carbunkle",
        "Cyclops",
        "Fairy",
        "Golem",
        "Ifrit",
        "Leviathan",
        "Lich",
        "Moogle",
        "Odin",
        "Ramuh",
        "Salamander",
        "Shiva",
        "Sylph",
        "Titan",
        "Zodiac"
      ]
    },
    "Thief": {
      "skillset": "Steal",
      "primaryBaseChance": 40,
      "abilities": [
        "Arm Aim",
        "Gil Taking",
        "Leg Aim",
        "Steal Accessory",
        "Steal Armor",
        "Steal Heart",
        "Steal Helmet",
        "Steal Shield",
        "Steal Status",
        "Steal Weapon"
      ]
    },
    "Time Mage": {
      "skillset": "Time Magic",
      "primaryBaseChance": 40,
      "abilities": [
        "Demi",
        "Demi 2",
        "Float",
        "Galaxy Stop",
        "Haste",
        "Haste 2",
        "Immobilize",
        "Meteor",
        "Mute",
        "Old",
        "Quick",
        "Reflect",
        "Slow",
        "Slow 2",
        "Stabilize Time",
        "Stop"
      ]
    },
    "Wizard": {
      "skillset": "Black Magic",
      "primaryBaseChance": 40,
      "abilities": [
        "Bolt",
        "Bolt 2",
        "Bolt 3",
        "Bolt 4",
        "Death",
        "Empower",
        "Fire",
        "Fire 2",
        "Fire 3",
        "Fire 4",
        "Flare",
        "Frog",
        "Ice",
        "Ice 2",
        "Ice 3",
        "Ice 4"
      ]
    }
  }
}
